import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

function Datenschutz() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Main Content */}
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          py: 4,
          px: { xs: 2.5, sm: 6.25 },
        }}
      >
        <Box
          sx={{
            p: { xs: 3, sm: 5 },
            maxWidth: '100%',
            overflowWrap: 'break-word',
          }}
        >
          <Typography variant="h1" component="h1" sx={{ mb: 2 }}>
            DATEN&shy;SCHUTZ&shy;ERKLÄRUNG
          </Typography>

          <Typography variant="body1" component="p" sx={{ mb: 3 }}>
            Im Folgenden informieren wir über die Erhebung personenbezogener Daten bei Nutzung unserer Website.
            Personenbezogene Daten sind alle Daten, die auf Sie persönlich beziehbar sind, z. B. Name, Adresse,
            E-Mail-Adressen, Nutzerverhalten. Wir haben umfangreiche technische und betriebliche Schutzvorkehrungen
            getroffen, um Ihre Daten vor zufälligen oder vorsätzlichen Manipulationen, Verlust, Zerstörung oder dem
            Zugriff unberechtigter Personen zu schützen. Unsere Sicherheitsverfahren werden regelmäßig überprüft und dem
            technologischen Fortschritt angepasst.
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            1. Verant&shy;wort&shy;licher für die Daten&shy;ver&shy;ar&shy;beitung
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Verantwortlicher gem. Art. 4 Abs. 7 EU-Datenschutz-Grundverordnung (DSGVO) ist die assona GmbH, Lorenzweg 5,
            in 12099 Berlin (siehe unser{' '}
            <Link
              variant="body2"
              style={{ cursor: 'pointer' }}
              href="https://assona.com/impressum/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Impressum
            </Link>
            )
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            2. Kontakt&shy;mög&shy;lich&shy;keit des Daten&shy;schutz&shy;beauf&shy;tragten
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Unseren Datenschutzbeauftragten erreichen Sie unter:
            <br />
            Herr Maximilian Mertin
            <br />
            c/o intersoft consulting services AG
            <br />
            Beim Strohhause 17, 20097 Hamburg
            <br />
            <Link variant="body2" style={{ cursor: 'pointer' }} href="mailto:datenschutz@assona.com">
              datenschutz@assona.com
            </Link>
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            3. Zweck und Rechts&shy;grundlage für die Verar&shy;beitung
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Persönliche Daten werden nur dann erhoben, wenn Sie uns diese von sich aus mitteilen, wie z.B. beim
            Abschluss einer Versicherung über unsere Website oder beim Ausfüllen des Kontaktformulars. Wir verwenden
            diese Daten ausschließlich für den Zweck, für den Sie Ihre Daten eingegeben haben. Für andere Zwecke erfolgt
            eine Verwendung nur nach ausdrücklichem Hinweis bzw. nach Einholung Ihrer Einwilligung, Art. 6 Abs. 1 lit.
            a) DSGVO. In bestimmten Fällen werden personenbezogene Daten aufgrund eines berechtigten Interesses nach
            Art. 6 Abs. 1 lit. f) DSGVO (siehe Ziffer 4) verarbeitet.
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            4. Verar&shy;beitung aufgrund eines berechtigten Interesses nach Art. 6 Abs. 1 lit. f) DSGVO
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Eine Verarbeitung von personenbezogenen Daten auf der Basis des Art. 6 Abs. 1 lit. f) DSGVO findet in
            folgenden Fällen statt:
          </Typography>

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            4.1. Erhebung von personen&shy;bezogenen Daten bei Besuch unserer Website
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Bei der bloß informatorischen Nutzung der Website erheben wir nur die personenbezogenen Daten, die Ihr
            Browser an unseren Server übermittelt. Wenn Sie unsere Website betrachten möchten, erheben wir die folgenden
            Daten, die für uns technisch erforderlich sind, um Ihnen unsere Website anzuzeigen und die Stabilität und
            Sicherheit zu gewährleisten:
          </Typography>
          <Typography variant="body1" component="div" sx={{ mb: 2 }}>
            <ul className="span-style text-blue">
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Das berechtigte Interesse liegt in der einwandfreien Darstellung seiner Internetpräsenz sowie der
            Gewährleistung von Stabilität und Sicherheit unserer Website.
          </Typography>

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            4.2. Einsatz von Cookies
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Was sind Cookies? Cookies sind Daten, die von einer Website, die Sie besuchen, auf Ihrem Rechner hinterlegt
            werden und eine erneute Zuordnung Ihres Browsers ermöglichen. Durch Cookies werden der Stelle, die den
            Cookie einsetzt, Informationen übermittelt. Cookies können verschiedene Informationen speichern, wie
            beispielsweise Ihre Spracheinstellung, die Besuchsdauer auf unserer Website oder Ihre dort getroffenen
            Eingaben. Dadurch wird z.B. vermieden, dass Sie bei jeder Nutzung erforderliche Formulardaten erneut
            eingegeben müssen. Die in Cookies gespeicherten Informationen können auch dazu genutzt werden, Präferenzen
            zu erkennen und Inhalte nach Interessengebieten auszurichten.
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Es gibt verschiedene Arten von Cookies: Session-Cookies sind Datenmengen, die nur vorübergehend im
            Arbeitsspeicher vorgehalten und gelöscht werden, wenn Sie Ihren Browser schließen. Dauerhafte oder
            persistente Cookies werden automatisiert nach einer vorgegebenen Dauer gelöscht, die sich je nach Cookie
            unterscheiden kann. Die Informationen können bei dieser Art Cookies auch in Textdateien auf Ihrem Rechner
            gespeichert werden. Sie können jedoch auch diese Cookies über die Einstellungen Ihres Browsers jederzeit
            löschen.
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Erstanbieter-Cookies werden von der Webseite gesetzt, die Sie gerade besuchen. Nur diese Webseite darf
            Informationen aus diesen Cookies lesen. Drittanbieter-Cookies werden von Organisationen gesetzt, die nicht
            Betreiber der Webseite sind, die Sie besuchen. Diese Cookies werden zum Beispiel von Marketing-Unternehmen
            verwendet.
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Die Rechtsgrundlagen für mögliche Verarbeitungen personenbezogener Daten mittels Cookies und deren
            Speicherdauer können variieren. Soweit Sie uns eine Einwilligung erteilt haben, ist Rechtsgrundlage Art. 6
            Abs. 1 lit. a) DSGVO. Soweit die Datenverarbeitung auf der Grundlage unserer überwiegenden berechtigten
            Interessen erfolgt, ist Rechtsgrundlage Art. 6 Abs. 1 lit. f) DSGVO. Der angegebene Zweck entspricht dann
            unserem berechtigten Interesse.
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Wir verwenden Cookies um den ordnungsgemäßen Betrieb der Website sicherzustellen, zur Bereitstellung
            grundlegender Funktionalitäten, zur Reichweitenmessung und - mit Ihrer Einwilligung - um unsere Services auf
            bevorzugte Interessengebiete zuzuschneiden. Dafür nutzen wir sowohl transiente Cookies also auch persistente
            Cookies
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Sie können bereits auf Ihrem Endgerät gespeicherte Cookies jederzeit löschen. Wenn Sie das Speichern von
            Cookies verhindern wollen, können Sie dies über die Einstellungen in Ihrem Internetbrowser. Eine Anleitung
            für gängige Browser finden Sie hier:{' '}
            <Link
              variant="body2"
              style={{ cursor: 'pointer' }}
              href="https://meine-cookies.org/cookies_verwalten/msie.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Internet Explorer
            </Link>
            <Typography variant="body2" component="span">
              ,{' '}
            </Typography>
            <Link
              variant="body2"
              style={{ cursor: 'pointer' }}
              href="https://meine-cookies.org/cookies_verwalten/firefox.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Firefox
            </Link>
            <Typography variant="body2" component="span">
              ,{' '}
            </Typography>
            <Link
              variant="body2"
              style={{ cursor: 'pointer' }}
              href="https://meine-cookies.org/cookies_verwalten/googlechrome.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Chrome
            </Link>
            <Typography variant="body2" component="span">
              ,{' '}
            </Typography>
            <Link
              variant="body2"
              style={{ cursor: 'pointer' }}
              href="https://www.youronlinechoices.com/de/funf-top-tipps/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Chrome mobile
            </Link>
            <Typography variant="body2" component="span">
              ,{' '}
            </Typography>
            <Link
              variant="body2"
              style={{ cursor: 'pointer' }}
              href="https://www.youronlinechoices.com/de/funf-top-tipps/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Microsoft Edge
            </Link>
            <Typography variant="body2" component="span">
              ,{' '}
            </Typography>
            <Link
              variant="body2"
              style={{ cursor: 'pointer' }}
              href="https://www.youronlinechoices.com/de/funf-top-tipps/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Safari
            </Link>
            <Typography variant="body2" component="span">
              ,{' '}
            </Typography>
            <Link
              variant="body2"
              style={{ cursor: 'pointer' }}
              href="https://www.youronlinechoices.com/de/funf-top-tipps/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Safari mobile
            </Link>
            . Alternativ können Sie auch sogenannte Ad-Blocker installieren. Bitte beachten Sie, dass einzelne
            Funktionen unserer Website möglicherweise nicht funktionieren, wenn Sie die Verwendung von Cookies
            deaktiviert haben.
          </Typography>

          {/* ggf. bei Einsatz von Matomo wieder einkommentieren, Checkbox formatieren und Funktion implementieren

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            4.3. Webseitenanalyse
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Für Zwecke der Analyse und Optimierung unserer Webseiten verwenden wir verschiedene Dienste, die im Folgenden dargestellt werden. So können wir z.B. analysieren, wie viele Nutzer unsere Seite besuchen, welche Informationen am gefragtesten sind oder wie Nutzer das Angebot auffinden. Wir erfassen unter anderem Daten darüber, von welcher Internetseite eine betroffene Person auf eine Internetseite gekommen ist (sogenannter Referrer), auf welche Unterseiten der Internetseite zugegriffen oder wie oft und für welche Verweildauer eine Unterseite betrachtet wurde. Dies hilft uns, unsere Angebote nutzerfreundlich auszugestalten und zu verbessern. Die dabei erhobenen Daten dienen nicht dazu, einzelne Benutzer persönlich zu identifizieren.
          </Typography>

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            Matomo
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Wir nutzen auf dieser Website den Open-Source-Webanalysedienst Matomo, einen Dienst der "InnoCraft Ltd", ein Unternehmen mit Sitz in 7 Waterloo Quay PO625 Wellington, Neuseeland. InnoCraft ist außerhalb der EU ansässig und hat einen Vertreter in der EU benannt: ePrivacy Holding GmbH, Große Bleichen 21, 20354 Hamburg (privacy@innocraft.com). Matomo verwendet Cookies, durch welche eine Analyse der Benutzung der Webseite möglich wird. Zu diesem Zweck werden die im Cookie erfassten Nutzungsinformationen (einschließlich Ihrer gekürzten IP-Adresse) an den in der EU befindlichen Server von Matomo übertragen und zu Nutzungsanalysezwecken gespeichert. Mit Matomo werden keine Daten an Server übermittelt, die außerhalb unserer Kontrolle liegen. Ihre IP-Adresse wird bei diesem Vorgang umgehend anonymisiert, so dass Sie als Nutzer für uns nicht identifizierbar sind. Die gesammelten Informationen über Ihre Benutzung dieser Webseite werden nicht an Dritte weitergegeben. Wir nutzen die erhobenen Daten zur statistischen Analyse des Nutzerverhaltens zum Zweck der Optimierung der Funktionalität und Stabilität der Website und zu Marketingzwecken. Die Interessen der Nutzer werden durch die Anonymisierung hinreichend gewahrt. Wir speichern die Analysedaten nur so lange es der Zweck der Datenverarbeitung erfordert, maximal jedoch 13 Monate.
          </Typography>

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            Rechtsgrundlage und Widerrufsmöglichkeit
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Für diese Datenverarbeitung ist Ihre Einwilligung, Art. 6 Abs. 1 lit. a) DSGVO. Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie die Datenschutz-Einstellungen unten rechts öffnen und dort den Regler entsprechend betätigen.
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Matomo verarbeitet zudem bestimmte Nutzerinformationen für einen kurzen Zeitraum. Anstelle eines Fingerabdrucks verwendet wir bei Matomo zum Schutz der Privatsphäre der Nutzer eine sog. config_id, um verschiedene Aktionen in einem kurzen Zeitfenster von bis zu 24 Stunden zu "Besuchen" zusammenzufassen. Die config_id des Besuchers ist ein zufällig gesetzter, zeitlich begrenzter Hash einer begrenzten Menge von Einstellungen und Attributen des Besuchers. Die config_id ist eine Zeichenkette, die für einen Besucher auf der Grundlage seines Betriebssystems, seines Browsers, seiner Browser-Plugins, seiner IP-Adresse und seiner Browsersprache berechnet wird. Dabei ist für die Erstellung der "config_id" eine anonymisierte IP-Adresse des Seitenbesuchers die Basis. Die mit der Matomo-Technologie erhobenen Daten werden auf Server von Matomo in Neuseeland übertragen und dort verarbeitet. Die Europäische Kommission hat für Neuseeland einen sog. Angemessenheitsbeschluss erlassen. Ein „Angemessenheitsbeschluss“ ist ein Beschluss, der von der Europäischen Kommission gemäß Artikel 45 DSGVO angenommen wird und durch den festgelegt wird, dass ein Drittland (d. h. ein Land, das nicht an die DSGVO gebunden ist) ein angemessenes Schutzniveau für personenbezogene Daten bietet.
          </Typography>

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            Rechtsgrundlage und Widerrufsmöglichkeit
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Für diese Datenverarbeitung ist das berechtigte Interesse Art. 6 Abs. 1 lit. f) DSGVO. Dieses besteht in der statistischen Analyse des Nutzerverhaltens zum Zweck der Optimierung der Funktionalität der Website und zu Marketingzwecken. Die Interessen der Nutzer werden durch die Anonymisierung hinreichend gewahrt. Sie die Möglichkeit, der Erfassung Ihrer Daten jederzeit zu widersprechen.
          </Typography>
          <Box variant="body2" component="div"
               sx={{px: 2, py: 1, mt: 2, mb: 2}}
                style={{backgroundColor: 'var(--color-alternate'}}>
            <Typography variant="body1" component="p" sx={{ mb: 2 }}>
              Sie haben die Möglichkeit zu verhindern, dass von Ihnen hier getätigte Aktionen analysiert und verknüpft werden. Dies wird Ihre Privatsphäre schützen, aber wird auch den Besitzer daran hindern, aus Ihren Aktionen zu lernen und die Bedienbarkeit für Sie und andere Benutzer zu verbessern.
            </Typography>
            <FormControlLabel
                control={
                  <Checkbox
                      name="sepaMandatAccepted"
                      sx={{
                        color: 'var(--color-primary-text)',
                        '&.Mui-checked': {
                          color: 'var(--color-primary-text)',
                        },
                      }}
                  />
                }
                label={
                  <Typography
                      variant="body2"
                      component="span"
                      className="p-bold-700"
                  >
                    Ihr Besuch dieser Webseite wird aktuell von der Matomo Webanalyse erfasst. Diese Checkbox abwählen für Opt-Out.
                  </Typography>
                }
            />
          </Box>
          */}

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            5. Daten&shy;über&shy;mittlung und Empfänger oder Kategorien von Empfängern
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Eine Übermittlung Ihrer Daten an Dritte findet grundsätzlich nicht statt, es sei denn, wir sind gesetzlich
            dazu verpflichtet, oder die Datenweitergabe ist zur Durchführung des Vertragsverhältnisses erforderlich oder
            Sie haben zuvor ausdrücklich in die Weitergabe Ihrer Daten eingewilligt.
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            6. Dauer der Speicherung
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Personenbezogene Daten die wir erheben, werden bei Fortfall des Zwecks der Verarbeitung oder innerhalb der
            gesetzlichen Aufbewahrungsfristen gelöscht.
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            7. Informa&shy;tionen über Bereit&shy;stellungs&shy;pflichten des Betroffenen
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Eine Übermittlung Ihrer Daten an Dritte findet grundsätzlich nicht statt, es sei denn, wir sind gesetzlich
            dazu verpflichtet, oder die Datenweitergabe ist zur Durchführung des Vertragsverhältnisses erforderlich oder
            Sie haben zuvor ausdrücklich in die Weitergabe Ihrer Daten eingewilligt.
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            8. Bestehen einer auto&shy;mati&shy;sierten Ent&shy;scheidungs&shy;findung ein&shy;schließ&shy;lich
            Profiling
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Eine Übermittlung Ihrer Daten an Dritte findet grundsätzlich nicht statt, es sei denn, wir sind gesetzlich
            dazu verpflichtet, oder die Datenweitergabe ist zur Durchführung des Vertragsverhältnisses erforderlich oder
            Sie haben zuvor ausdrücklich in die Weitergabe Ihrer Daten eingewilligt.
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            9. Ihre Rechte
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
          </Typography>

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            9.1. Allgemeine Rechte
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Sie haben ein Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch gegen
            die Verarbeitung und auf Datenübertragbarkeit. Soweit eine Verarbeitung auf Ihrer Einwilligung beruht, haben
            Sie das Recht, diese uns gegenüber mit Wirkung für die Zukunft zu widerrufen.
          </Typography>

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            9.2. Rechte bei der Daten&shy;verar&shy;beitung nach dem berech&shy;tigten Interesse
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Sie haben gem. Art. 21 Abs.1 DSGVO das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben,
            jederzeit gegen die Verarbeitung sie betreffender personenbezogener Daten, die aufgrund von Art. 6 Abs.1 e
            DSGVO (Datenverarbeitung im öffentlichen Interesse) oder aufgrund Artikel 6 Abs.1 f DSGVO (Datenverarbeitung
            zur Wahrung eines berechtigten Interesses) erfolgt, Widerspruch einzulegen, dies gilt auch für ein auf diese
            Vorschrift gestütztes Profiling. Im Falle Ihres Widerspruchs verarbeiten wir Ihre personenbezogenen Daten
            nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre
            Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder
            Verteidigung von Rechtsansprüchen.
          </Typography>

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            9.3. Rechte bei Direkt&shy;werbung
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Sofern wir Ihre personenbezogenen Daten verarbeiten, um Direktwerbung zu betreiben, so haben Sie gem. Art.
            21 Abs. 2 DSGVO das Recht, jederzeit Widerspruch gegen die Verarbeitung der Sie betreffenden
            personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen, dies gilt auch für das Profiling, soweit
            es mit solcher Direktwerbung in Verbindung steht.
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Im Falle Ihres Widerspruchs gegen die Verarbeitung zum Zwecke der Direktwerbung werden wir Ihre
            personenbezogenen Daten nicht mehr für diese Zwecke verarbeiten.
          </Typography>

          <Typography variant="h3" component="h3" sx={{ mt: 4, mb: 2 }}>
            9.4. Recht auf Beschwerde bei einer Aufsichts&shy;behörde
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Sie haben zudem das Recht, sich bei einer zuständigen Datenschutz-Aufsichtsbehörde über die Verarbeitung
            Ihrer personenbezogenen Daten durch uns zu beschweren.
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            10. Kontakt&shy;auf&shy;nahme per E-Mail oder Kontakt&shy;formular
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Bei Ihrer Kontaktaufnahme mit uns per E-Mail oder über ein Kontaktformular werden die von Ihnen mitgeteilten
            Daten (Ihre E-Mail-Adresse und Ihr Name) von uns gespeichert, um Ihre Fragen zu beantworten. Soweit wir über
            unser Kontaktformular Eingaben abfragen, die nicht für eine Kontaktaufnahme erforderlich sind, haben wir
            diese stets als optional gekennzeichnet. Diese Angaben dienen uns zur Konkretisierung Ihrer Anfrage und zur
            verbesserten Abwicklung Ihres Anliegens. Eine Mitteilung dieser Angaben erfolgt ausdrücklich auf
            freiwilliger Basis und mit Ihrer Einwilligung, Art. 6 Abs. 1 lit. a) DSGVO. Soweit es sich hierbei um
            Angaben zu Kommunikationskanälen (beispielsweise E-Mail-Adresse, Telefonnummer) handelt, willigen Sie
            außerdem ein, dass wir Sie ggf. auch über diesen Kommunikationskanal kontaktieren, um Ihr Anliegen zu
            beantworten. Diese Einwilligung können Sie selbstverständlich jederzeit für die Zukunft widerrufen.
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Die in diesem Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr erforderlich
            ist, oder schränken die Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten bestehen.
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            11. Daten&shy;sicherheit
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Wir haben umfangreiche technische und betriebliche Schutzvorkehrungen getroffen, um Ihre Daten vor
            zufälligen oder vorsätzlichen Manipulationen, Verlust, Zerstörung oder dem Zugriff unberechtigter Personen
            zu schützen. Unsere Sicherheitsverfahren werden regelmäßig überprüft und dem technologischen Fortschritt
            angepasst.
          </Typography>

          <Typography variant="h2" component="h2" sx={{ mt: 4, mb: 2 }}>
            12. Daten&shy;über&shy;mitt&shy;lung und beab&shy;sich&shy;tigte Daten&shy;über&shy;mitt&shy;lung in ein
            Dritt&shy;land oder eine inter&shy;natio&shy;nale Organi&shy;sation
          </Typography>
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Eine Übermittlung Ihrer Daten an Dritte findet grundsätzlich nicht statt, es sei denn, wir sind gesetzlich
            dazu verpflichtet, oder die Datenweitergabe ist zur Durchführung des Vertragsverhältnisses erforderlich oder
            Sie haben zuvor ausdrücklich in die Weitergabe Ihrer Daten eingewilligt.
          </Typography>

          {/*
          <Divider sx={{ my: 4 }} />

          <Typography variant="body2" color="text.secondary" align="center">
            Stand: {new Date().toLocaleDateString('de-DE')}
          </Typography>
          */}
        </Box>
      </Container>
    </Box>
  );
}

export default Datenschutz;
